import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=2a0055d8&"
import script from "./Properties.vue?vue&type=script&lang=js&"
export * from "./Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/l-setting-for-configuration-tool/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a0055d8')) {
      api.createRecord('2a0055d8', component.options)
    } else {
      api.reload('2a0055d8', component.options)
    }
    module.hot.accept("./Properties.vue?vue&type=template&id=2a0055d8&", function () {
      api.rerender('2a0055d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UIComponents/Properties.vue"
export default component.exports